// extracted by mini-css-extract-plugin
export default {"navigationMobile":"NavigationMobile_navigationMobile__fPyVa","burger":"NavigationMobile_burger__JXROp","navigation":"NavigationMobile_navigation__CaW3C"};